<template>
  <div>
    <Dialog
      :header="$t('operacion.pagosCuenta.aplicar.titulo')"
      :modal="true"
      :visible.sync="displayModal"
      :contentStyle="{ overflow: 'visible' }"
      @hide="closeDialog"
    >
      <Errors v-show="this.errors.length > 0" :errors="this.errors" />
      <div class="p-grid">
        <div class="p-col-12 p-lg-6">
          <div class="dashboard">
            <div class="highlight-box">
              <div class="highlight-details">
                <i class="pi pi-money-bill"></i>
                <span>{{
                  $t("operacion.pagosCuenta.aplicar.importePendiente")
                }}</span>
                <span class="count">{{
                  (pagoCuenta.importe - importeTotalAPlicado)
                    | toCurrency("es-ES", this.pagoCuenta.divisa)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-12 p-field">
          <label for="referenciaCliente"
            ><b>{{ $t("operacion.pagosCuenta.aplicar.tituloTabla") }}</b></label
          >
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-id-card"></i>
            </span>
            <DataTable
              :value="reclamaciones"
              :lazy="true"
              class="p-datatable-responsive"
              :autoLayout="true"
              editMode="cell"
              responsiveLayout="scroll"
              @cell-edit-complete="onCellEditComplete"
            >
              <Column
                field="token"
                :header="$t('reclamacion.token')"
                headerStyle="width: 7em"
              >
                <template #body="slotProps">
                  <span class="p-column-title">{{
                    $t("reclamacion.token")
                  }}</span>
                  {{ slotProps.data.token }}
                </template>
              </Column>
              <Column field="estado" :header="$t('reclamacion.estado')">
                <template #body="slotProps">
                  <span class="p-column-title">{{
                    $t("reclamacion.estado")
                  }}</span>
                  <span
                    :class="
                      getEstiloEstadoColor(slotProps.data.literalEstado.valor)
                    "
                    >{{ slotProps.data.literalEstado.valor }}</span
                  >
                </template>
              </Column>
              <Column
                field="totalPendiente"
                :header="$t('reclamacion.totalPendiente')"
              >
                <template #body="slotProps">
                  <span class="p-column-title">{{
                    $t("reclamacion.totalPendiente")
                  }}</span>
                  {{
                    slotProps.data.totalPendiente
                      | toCurrency("es-ES", slotProps.data.divisa)
                  }}
                </template>
              </Column>
              <Column
                field="operacion.producto.contrato.cliente.idLegal"
                :header="$t('reclamacion.detalleReclamacion.cliente')"
              >
                <template #body="slotProps">
                  <span class="p-column-title">{{
                    $t("reclamacion.detalleReclamacion.cliente")
                  }}</span>
                  {{
                    slotProps.data.clienteIdLegal +
                    " - " +
                    getFullName(
                      slotProps.data.clienteNombre,
                      slotProps.data.clienteApellidos,
                      ""
                    )
                  }}
                </template>
              </Column>
              <Column
                field="importeAplicado"
                :header="$t('operacion.pagosCuenta.importe')"
              >
                <template #body="slotProps" style="cursor: pointer">
                  {{
                    slotProps.data.importeAplicado
                      | toCurrency("es-ES", pagoCuenta.divisa)
                  }}
                </template>
                <template #editor="slotProps">
                  <InputText v-model="slotProps.data.importeAplicado" />
                </template>
              </Column>

              <!--<InputNumber id="horizontal" v-model="value18" showButtons buttonLayout="horizontal" :step="0.25"
                    decrementButtonClass="p-button-danger" incrementButtonClass="p-button-success" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" mode="currency" currency="EUR" />-->
            </DataTable>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          @click.prevent="altaPagoCuenta()"
          :label="$t('common.buttons.save')"
          class=""
          icon="pi pi-save"
          iconPos="left"
        />
        <Button
          @click.prevent="closeDialog()"
          :label="$t('common.buttons.cancel')"
          class="p-button-secondary"
          icon="pi pi-times"
          iconPos="left"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import StringsMixin from "@/utils/strings";
import CurrencyMixin from "@/utils/currency";
import ReclamacionMixin from "@/utils/reclamacion";
import Errors from "@/components/utilidades/Errors.vue";
import { QUERY_LISTADO_RECLAMACION } from "@/graphQLQueries/ReclamacionQueries";
import {
  ALTA_APLICADOS,
  BORRAR_APLICADOS,
} from "@/graphQLQueries/AplicadosQueries";

export default {
  mixins: [StringsMixin, CurrencyMixin, ReclamacionMixin],
  name: "AltaAplicado",
  props: ["operacionToken", "displayAlta", "idOperacion", "pagoCuenta"],
  components: {
    Errors: Errors,
  },
  data() {
    return {
      displayModal: this.displayAlta,
      errors: [],
      importeTotalAPlicado: 0,
      reclamaciones: null,
      reclamacion: null,
      aplicados: [],
      reclamacionesAplicadas: [],
    };
  },
  created() {
    this.getDatos();
  },
  methods: {
    classColumn() {
      return "p-col-12 p-lg-6";
    },
    altaPagoCuenta() {
      let aplicados = [];
      let errores = false;
      this.errors = [];
      this.reclamaciones.forEach((reclamacion) => {
        if (!this.isPositiveInteger(reclamacion.importeAplicado)) {
          if (!errores) {
            this.errors.push(
              this.$i18n.t("operacion.pagosCuenta.errores.noNumber")
            );
          }
          errores = true;
        } else {
          if (reclamacion.importeAplicado > 0) {
            aplicados.push({
              idPagoCuenta: this.pagoCuenta.id,
              tokenReclamacion: reclamacion.token,
              importe: reclamacion.importeAplicado,
            });
          } else if (reclamacion.importeAplicado == 0) {
            this.borrarAplicado({
              idPagoCuenta: this.pagoCuenta.id,
              tokenReclamacion: reclamacion.token,
            });
          }
        }
      });
      if (!errores) {
        this.closeDialog();
        this.$apollo
          .mutate({
            mutation: ALTA_APLICADOS,
            variables: {
              altaAplicadosRequest: {
                aplicados: aplicados,
              },
            },
          })
          .then(() => {
            this.closeDialog();
          })
          .catch((exception) => {
            this.errors = [];
            exception.graphQLErrors.forEach((error) => {
              this.errors.push(
                this.$i18n.t("operacion.pagosCuenta.errores." + error.message)
              );
            });
          });
      }
    },
    closeDialog() {
      this.$emit("close-dialog", null);
      this.displayModal = false;
      this.errors = [];
    },
    async getDatos() {
      await this.getAplicados();
    },
    onCellEditComplete(event) {
      if (!this.reclamaciones[event.index]) {
        return;
      }
      this.errors = [];

      const editingCellValue = this.reclamaciones[event.index][event.field];
      const _importeTotalAplicado = this.importeTotalAPlicado;
      if (this.isPositiveInteger(editingCellValue)) {
        if (editingCellValue == 0) {
          this.importeTotalAPlicado = 0;
          this.reclamaciones.forEach((reclamacion) => {
            this.importeTotalAPlicado += parseFloat(
              reclamacion.importeAplicado
            );
          });
        } else {
          this.importeTotalAPlicado = 0;
          this.reclamaciones.forEach((reclamacion) => {
            this.importeTotalAPlicado += parseFloat(
              reclamacion.importeAplicado
            );
          });
          if (this.importeTotalAPlicado > this.pagoCuenta.importe) {
            this.errors.push(
              this.$i18n.t(
                "operacion.pagosCuenta.aplicar.error.importeAplicado"
              )
            );
            this.importeTotalAPlicado = _importeTotalAplicado;
            event.preventDefault();
          }
        }
      } else {
        this.errors.push(
          this.$i18n.t("operacion.pagosCuenta.aplicar.error.noNumber")
        );
        event.preventDefault();
      }
    },
    borrarAplicado(request) {
      this.$apollo.mutate({
        mutation: BORRAR_APLICADOS,
        variables: {
          altaAplicadoRequest: {
            idPagoCuenta: request.idPagoCuenta,
            tokenReclamacion: request.tokenReclamacion,
          },
        },
      });
    },
    isPositiveInteger(val) {
      return !isNaN(val) && Number(val) >= 0;
    },
    getAplicados() {
      this.aplicados = [];
    },
  },
  watch: {
    $route(to, from) {
      console.log(`${from} => ${to}`);
      this.show = false;
    },
  },
  computed: {
    getLocale() {
      return this.$i18n.t("calendar");
    },
  },
  apollo: {
    reclamaciones: {
      query: QUERY_LISTADO_RECLAMACION,
      variables() {
        return {
          filter: ["operacion.id~eq=" + this.idOperacion],
          sort: ["-fechaAlta"],
          page: 0,
          size: 50,
          idioma: this.$i18n.locale,
        };
      },
      update(data) {
        this.importeTotalAPlicado = 0;
        data.listaReclamaciones.results.forEach((reclamacion) => {
          reclamacion["importeAplicado"] = 0;
          this.pagoCuenta.aplicados.forEach((aplicado) => {
            if (aplicado.reclamacionId === reclamacion.id) {
              reclamacion["importeAplicado"] = aplicado.importe;
            }
          });
          this.importeTotalAPlicado += reclamacion["importeAplicado"];
        });
        const estadosNoValidos = ["CANCELADA", "EXPIRADA", "RECUPERADA"];
        return data.listaReclamaciones.results.filter(
          (reclamacion) => !estadosNoValidos.includes(reclamacion.estado)
        );
      },
      error() {
        this.$toast.add({
          severity: "error",
          summary: this.$t("common.error.updateTitle"),
          detail: this.$t("common.error.update"),
          life: 5000,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.marginBottom {
  margin-bottom: 0.3cm;
  margin-top: 1cm;
}

.highlight-box .initials.ov {
  background-color: rgb(0, 123, 229);
  color: rgb(0, 68, 143);
}
.highlight-box .initials.os {
  background-color: rgb(239, 98, 98);
  color: rgb(168, 61, 59);
}
.highlight-box .initials.or {
  background-color: rgb(32, 208, 119);
  color: rgb(3, 141, 74);
}
.highlight-box .initials.on {
  background-color: rgb(249, 200, 81);
  color: rgb(181, 140, 43);
}
.dashboard .highlight-box .highlight-details {
  background-color: #f4f4f4;
}
</style>
